import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, GeoJSON, Tooltip } from 'react-leaflet';
import { countryFlags } from './data/countryFlags';
import { countryCapitalsNl } from './data/countryCapitalsNl';
import { ProvinceCoA as ProvinceCoA } from './data/ProvinceCoA';
import { ProvinceCapitals as ProvinceCapitals } from './data/ProvinceCapitals';
import 'leaflet/dist/leaflet.css';

const App = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [quizMode, setQuizMode] = useState(null);
  const popupRef = useRef(null);

  useEffect(() => {
    if (quizMode) {
      const mapFile = quizMode === 'quiz1' ? '/data/map.json' : '/data/mapAlt.json';
      fetch(mapFile)
        .then((res) => res.json())
        .then((data) => {
          setGeoJsonData(data);
          const randomFeature = data.features[Math.floor(Math.random() * data.features.length)];
          setSelectedCountry(randomFeature);
        });
    }
  }, [quizMode]);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setPopupData(null);
      }
    };
    if (popupData) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupData]);

  const onEachCountry = (feature, layer) => {
    const countryName = feature.properties.NAME_NL;
    const isoCode = feature.properties.ISO_A3;
    const flags = quizMode === 'quiz1' ? countryFlags : ProvinceCoA;
    const capitals = quizMode === 'quiz1' ? countryCapitalsNl : ProvinceCapitals;
    const flagUrl = flags[isoCode];

    if (selectedCountry && isoCode === selectedCountry.properties.ISO_A3) {
      layer.setStyle({ fillColor: 'green', fillOpacity: 0.5, color: '#000', weight: 1 });
      layer.bindTooltip("<img src=" + flagUrl + " width=60px style='display:block;background:white'>", { permanent: true, direction: 'center', className: 'country-label' });
    } else {
      layer.setStyle({ fillColor: '#ccc', fillOpacity: 0.5, color: '#000', weight: 1 });
    }

    layer.on({
      click: () => {
        if (selectedCountry.properties.ISO_A3 === feature.properties.ISO_A3) {
          const capital = capitals[isoCode];
          setPopupData({
            countryName,
            capital,
            flagUrl,
          });
        }
        setSelectedCountry(feature);
      },
    });
  };

  const reloadQuiz = () => {
    const randomFeature = geoJsonData.features[Math.floor(Math.random() * geoJsonData.features.length)];
    setSelectedCountry(randomFeature);
  };

  if (!quizMode) {
    return (
      <div style={{ padding: '2rem' }}>
        <h1>Kies een quiz</h1>
        <button onClick={() => setQuizMode('quiz1')} style={{ marginRight: '1rem' }}>Quiz 1: Europese land</button>
        <button onClick={() => setQuizMode('quiz2')}>Quiz 2: Nederlandse provincie</button>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh', padding: '16px' }}>
      <button onClick={() => setQuizMode(null)} style={{ marginBottom: '1rem' }}>
        Terug naar quizselectie
      </button>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>
        {quizMode === 'quiz1' ? 'Quiz: Herken het Europese land' : 'Quiz: Herken de Nederlandse provincie'}
      </h1>
      <button onClick={reloadQuiz}>
        {quizMode === 'quiz1' ? 'Volgende land' : 'Volgende provincie'}
      </button>
      <MapContainer
	    center={quizMode === 'quiz1' ? [54, 15] : [52.1, 5.3]}
        zoom={quizMode === 'quiz1' ? 4 : 7}
        style={{ height: '80vh', width: '100%' }}
	  >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {geoJsonData && (
          <GeoJSON data={geoJsonData} onEachFeature={onEachCountry} key={selectedCountry?.properties?.ISO_A3 || "none"} />
        )}
      </MapContainer>

      {popupData && (
        <div
		  ref={popupRef}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            padding: '1rem',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0,0,0,0.2)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img src={popupData.flagUrl} style={{ width: '120px' }} />
          <div>
            <h3 style={{ margin: 0, fontSize: '28px' }}>{popupData.countryName}</h3>
            <p style={{ margin: 0, fontSize: '28px' }}>Hoofdstad: <strong>{popupData.capital}</strong></p>
          </div>
          <button onClick={() => {
            setPopupData(null);
            reloadQuiz();
          }}>X</button>
        </div>
      )}
    </div>
  );
};

export default App;
